import * as React from 'react';



export default class Close extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink" onClick={this.props.onClick}>
       <g id="exzeo_2.x_icon_set" fillRule="evenodd" transform="translate(-156.000000, -225.000000)">
            <g id="Group-70" transform="translate(156.000000, 225.000000)">
                <g id="Group-71"></g>
                <g id="Page-1" transform="translate(0.000000, 1.000000)"></g>
            </g>
            <g id="Group-72" transform="translate(157.000000, 226.000000)">
                <path d="M0.436717647,0.4368 L13.6131882,13.6132706" id="Stroke-1"></path>
                <path d="M13.1764706,0 L0,13.1764706" id="Stroke-3"></path>
            </g>
        </g>
      </svg>
    )
  }
}
